import type { StaticEntityType } from "@config";

export const getTabsOptions = (entity: StaticEntityType) =>
  entity.children.map((child) => {
    const { tabTitle, tabIcon, isTabDefault } = child.settings;
    return {
      name: tabTitle,
      icon: tabIcon,
      isDefault: isTabDefault,
      id: child.id,
    };
  });
